import { Nutrition } from 'models/Nutrition'
export const nutritionFormatter = (nutrition: Nutrition) => {
    const base = {
        ...nutrition,
        caloriesPerKilo: `${nutrition.caloriesPerKilo.toFixed()}`,
        crudeFatPercent: `${nutrition.crudeFatPercent.toFixed(1)}%`,
        crudeFiberPercent: `${nutrition.crudeFiberPercent.toFixed(1)}%`, 
        crudeProteinPercent: `${nutrition.crudeProteinPercent.toFixed(1)}%`, 
        moisturePercent: `${nutrition.moisturePercent.toFixed(1)}%`, 
        caloriesPerOunce: `${nutrition.caloriesPerOunce.toFixed()}`,
        caloriesPerCup: undefined,
        proteinLabel: nutrition.protein.toLowerCase(),
        proteinLabelCapitalized: nutrition.protein.charAt(0).toUpperCase() + nutrition.protein.slice(1).toLowerCase()
      }

    if ('caloriesPerCup' in nutrition) {
      return {
        ...base,
        caloriesPerCup: nutrition.caloriesPerCup.toFixed(),
      }
    }

    return base
  }
